module.exports = __webpack_public_path__ + "img/transfer-signboard-icon.a19b1914.svg";